<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-question-mark-circle`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c12.15 0 22 9.85 22 22s-9.85 22-22 22S2 36.15 2 24 11.85 2 24 2zm0 4C14.059 6 6 14.059 6 24s8.059 18 18 18 18-8.059 18-18S33.941 6 24 6zm1 26a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2a1 1 0 011-1h2zm-1.284-20c2.377 0 4.352.576 5.925 1.727C31.214 14.88 32 16.584 32 18.845c0 1.386-.342 2.553-1.026 3.502-.4.576-1.167 1.311-2.303 2.207l-1.12.88c-.61.48-1.016 1.04-1.216 1.679-.054.175-.102.499-.143.974a1 1 0 01-.996.913h-2.24a1 1 0 01-1-1l.002-.046.003-.046c.129-1.392.267-2.273.414-2.642.273-.688.978-1.48 2.114-2.375l1.152-.912c.379-.288 2.33-1.662 2.33-2.878 0-1.217-.212-1.665-.823-2.332-.61-.668-1.986-.883-3.227-.883-1.22 0-2.263.324-2.773 1.145a5.78 5.78 0 00-.569 1.2 4.18 4.18 0 00-.146.614 1 1 0 01-.985.831h-2.355a1 1 0 01-1-1l.002-.056.005-.057a8.34 8.34 0 01.078-.557c.39-2.172 1.377-3.768 2.962-4.79 1.241-.81 2.767-1.216 4.576-1.216z"/></svg>
</template>
<script>

export default {
  name: 'IconQuestionMarkCircle',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
